import { render, staticRenderFns } from "./ToolsTransverseTraction.vue?vue&type=template&id=365fbfa2&scoped=true"
import script from "./ToolsTransverseTraction.vue?vue&type=script&lang=js"
export * from "./ToolsTransverseTraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365fbfa2",
  null
  
)

export default component.exports